module.exports = __webpack_public_path__ + "img/11_123.0218c7e8.png";